/**
 * Custom Password Match Directive
 * Replaces angular-password dependency
 * Based on original angular-password implementation
 */
(function() {
    'use strict';

    function $Password() {
        function link(scope, element, attrs, ctrls) {
            var formController = ctrls[1];
            var ngModel = ctrls[0];
            var otherPasswordModel = formController[attrs.matchPassword];

            if (!otherPasswordModel) {
                console && console.warn && console.warn('matchPassword: Could not find the form field with name "' + attrs.matchPassword + '"');
                return;
            }

            var getMatchValue = function() {
                return otherPasswordModel.$viewValue;
            };

            scope.$watch(getMatchValue, function() {
                ngModel.$$parseAndValidate();
            });

            // if ng1.3+
            if (ngModel.$validators) {
                ngModel.$validators.passwordMatch = function(modelValue) {
                    return (!modelValue && !otherPasswordModel.$modelValue) || (modelValue === otherPasswordModel.$modelValue);
                };
            } else {
                ngModel.$parsers.push(function(value) {
                    ngModel.$setValidity('passwordMatch', (!value && !otherPasswordModel.$viewValue) || value === otherPasswordModel.$viewValue);
                    return value;
                });
            }

            otherPasswordModel.$parsers.push(function(value) {
                ngModel.$setValidity('passwordMatch', (!value && !ngModel.$viewValue) || value === ngModel.$viewValue);
                return value;
            });
        }

        var controllers = ['^ngModel', '^form'];

        return {
            restrict: 'A',
            require: controllers,
            link: link
        };
    }

    angular.module('passwordMatch', []).directive('matchPassword', $Password);

    // Support for legacy module names
    angular.module('ngPassword', ['passwordMatch']);
    angular.module('angular.password', ['passwordMatch']);
    angular.module('angular-password', ['passwordMatch']);

})(); 
